import { useRef } from 'react';
import { Button } from '@mui/material';

import StyledTextField from '../styled-text-field/styled-text-field.js';

interface Props {
    value: string;
    label?: string;
}

const CopyableInput: FC<Props> = ({ value, label }) => {
    const inputRef = useRef<HTMLInputElement>();

    const copy = () => {
        window.navigator.clipboard.writeText(value);
    };

    const inputFocus = () => {
        if (inputRef.current) {
            inputRef.current.select();
        }
    };

    return (
        <div className="copyable-input">
            <StyledTextField
                value={value}
                label={label}
                onFocus={inputFocus}
                inputRef={inputRef}
                slotProps={{ inputLabel: { shrink: true } }}
                fullWidth
            />
            <Button variant="outlined" className="copy-icon" onClick={copy}>
                Copy
            </Button>
        </div>
    );
};

export default CopyableInput;
